import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslationModule } from 'farmcloud-core';
import { WeekNumberComponent } from './components/week-number/week-number.component';

@NgModule({
  declarations: [WeekNumberComponent],
  imports: [CommonModule, TranslationModule],
  exports: [WeekNumberComponent],
  providers: []
})
export class SharedDatesModule {}
